import React, { useContext, useState, useEffect } from "react";
import { doc, onSnapshot, addDoc, collection, Timestamp, updateDoc, deleteDoc } from "firebase/firestore";
import { MdPermContactCalendar } from "react-icons/md";
import toast, { Toaster } from 'react-hot-toast';
import {
  useParams,
  useHistory,
  useLocation
} from "react-router-dom";
import MainLayout from '../layouts/MainLayout'
import UserInfos from '../components/UserInfos'
import LoadableButton from '../components/LoadableButton'
import {FirebaseContext} from '../services/Firebase/Context'
import {AuthContext} from '../services/Session/Context'

const Appointment = () => {
  const { id } = useParams();
  const { db } = useContext(FirebaseContext)
  const { user } = useContext(AuthContext)
  const history = useHistory();
  const [record, setRecord] = useState({})
  const [loading, setLoading] = useState(false)
  const [loadingNew, setLoadingNew] = useState(false)
  const { state } = useLocation();

  useEffect(() => {
    if(!id) return
    const unsubscribe = onSnapshot(doc(db, "appointments", id), (doc) => {
      setRecord({id: doc.id, ...doc.data()})
    });
    return () => unsubscribe()
  }, [db, id])

  const handleSave = (e) => {
    e.preventDefault()
    if(!state.selectedDate || !record.phone || !record.name || !record.comments) {
      toast.error('Tous les champs sont obligatoires. Veuillez les renseigner');
      return
    }
    setLoading(true)

    const appointment = {
      date: Timestamp.fromDate(state.selectedDate),
      createdAt: Timestamp.now(),
      createdBy: user.uid,
      phone: record.phone,
      name: record.name,
      comments: record.comments,
      isBusiness: record.isBusiness || false,
      status: 'accepted',
      organisationId: user.organisationId,
    }
    addDoc(collection(db, "appointments"), appointment)
    .then(() => {
      history.goBack()
      setLoading(false)
    })
    .catch((err) => {
      setLoading(false)
      toast.error('Erreur veuillez reessayer');
    });
  }

  const handleDelete = (e) => {
    e.preventDefault()
    if(!id) return
    if(window.confirm("Voulez-vous vraiment supprimer ce rendez-vous ? Si oui, pensez à convenir d'une autre date avec votre client !")) {
      setLoading(true)
      if( record.status === 'new')
      {
        setLoadingNew(true)
      }
      deleteDoc(doc(db, 'appointments', id))
      .then(() => {
        history.goBack()
        setLoadingNew(false)
        setLoading(false)
      })
      .catch((err) => {
        setLoadingNew(false)
        setLoading(false)
        toast.error('Erreur veuillez reessayer');
      });
    }
  }

  const handleAccept = (e) => {
    e.preventDefault()
    if(!id) return
    setLoading(true)
    setLoadingNew(true)
    updateDoc(doc(db, "appointments", id), {
      status: 'accepted',
      acceptedBy: user.uid,
      acceptedAt: Timestamp.now()
    })
    .then(() => {
      window.location = `sms:${record.phone};?&body=Cher(e) client(e),%0DVotre rendez-vous du ${record.date.toDate().toLocaleDateString()} a été confirmée.%0DCordialement,%0D${user.organisation.name}`
      setLoadingNew(false)
      setLoading(false)
    })
    .catch((err) => {
      setLoadingNew(false)
      setLoading(false)
      toast.error('Erreur veuillez reessayer');
    });
  }

  return (
    <MainLayout>
      <UserInfos/>
      <h1 className="text-4xl font-semibold text-gray-800 dark:text-white mb-2">
        Prise de rendez-vous
      </h1>
      <h2 className="text-gray-400">Récapitulatif du rendez-vous</h2>
      <div className="mt-5">
      <form className="shadow-md">
        <div className="p-4 bg-gray-100 border-t-2 border-blue-400 rounded-lg bg-opacity-5">
          <div className="max-w-sm mx-auto md:w-full md:mx-0">
            <div className="inline-flex items-center space-x-4">
              <MdPermContactCalendar className="bg-blue-200 rounded-full h-10 w-10 p-2" color="white" />
              <h1 className="text-gray-600">
                Informations sur la demande
              </h1>
            </div>
          </div>
        </div>
        <div className="space-y-6 bg-white">
        <div className="items-center w-full p-4 space-y-4 text-gray-500 md:inline-flex md:space-y-0">
            <h2 className="max-w-sm mx-auto md:w-1/3">
              Date de rendez-vous
            </h2>
            <div className="max-w-sm mx-auto space-y-5 md:w-2/3">
              <div>
                <div className=" relative ">
                  <input
                    disabled
                    type="text"
                    value={
                      id
                      ? (record.date && record.date.toDate().toLocaleDateString())
                      : state.selectedDate.toLocaleDateString()
                    }
                    className="rounded-lg border-transparent flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                    placeholder="Date"
                    onChange={(e) => setRecord({ ...record, date: e.target.value})}
                  />
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div className="items-center w-full p-4 space-y-4 text-gray-500 md:inline-flex md:space-y-0">
            <h2 className="max-w-sm mx-auto md:w-1/3">
              Contact
            </h2>
            <div className="max-w-sm mx-auto space-y-5 md:w-2/3">
              <div>
                <div className=" relative ">
                  <input
                    disabled={!!id}
                    type="text"
                    value={record.name}
                    className="rounded-lg border-transparent flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                    placeholder="Nom"
                    onChange={(e) => setRecord({ ...record, name: e.target.value})}
                  />
                </div>
              </div>
              <div>
                <div className=" relative ">
                  <input
                    type="tel"
                    disabled={!!id}
                    value={record.phone}
                    className="rounded-lg border-transparent flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                    placeholder="Téléphone"
                    onChange={(e) => setRecord({ ...record, phone: e.target.value})}
                  />
                </div>
              </div>
              <div>
                <div className=" relative ">
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      disabled={!!id}
                      checked={record.isBusiness}
                      className="h-6 w-6"
                      onChange={(e) => setRecord({ ...record, isBusiness: e.target.checked})}
                    />
                    <span className="ml-2">Client professionnel</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <hr/>
          <div className="items-center w-full p-4 space-y-4 text-gray-500 md:inline-flex md:space-y-0">
            <h2 className="max-w-sm mx-auto md:w-1/3">
              Commentaires
            </h2>
            <div className="max-w-sm mx-auto space-y-5 md:w-2/3">
              <div>
                <div className=" relative ">
                <label className="text-gray-700" htmlFor="name">
                  <textarea
                    className="flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 rounded-lg text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                    placeholder="Vos commentaires"
                    disabled={!!id}
                    rows="5"
                    cols="40"
                    value={record.comments}
                    onChange={(e) => setRecord({ ...record, comments: e.target.value})}
                  />
                </label>
                </div>
              </div>
            </div>
          </div>
          <hr/>
          <div className="w-full px-4 pb-4 ml-auto text-gray-500 md:w-1/3">
            {/* dirty fix to get bg-red-600 declare in css for loadable button*/}
            <div className="bg-red-600"></div>
            {
              id
              ? (
                record.status === 'new' || loadingNew
                ? <div className='flex justify-between'>
                  <LoadableButton
                    className='mr-5'
                    title="Refuser"
                    loading={loading}
                    onClick={handleDelete}
                    color='red'
                  />
                  <LoadableButton
                    title="Accepter"
                    loading={loading}
                    onClick={handleAccept}
                    color='green'
                  />
                </div>
                : <LoadableButton
                  title="Supprimer"
                  loading={loading}
                  onClick={handleDelete}
                  color='red'
                />
              )
              : <LoadableButton
                title="Enregistrer"
                loading={loading}
                disabled={!!id}
                onClick={handleSave}
                color='blue'
              />
            }
          </div>
        </div>
      </form>
      </div>
      <Toaster />
    </MainLayout>
  );
}

export default Appointment
